import { defineMessages } from 'react-intl';

const messages = defineMessages({
  regAndLegalNote: {
    id: 'App.LeaseApplicationForm.regAndLegalNote',
    defaultMessage:
      // eslint-disable-next-line max-len
      'You must provide at least one of the following: Driver License/State ID (if so, select a State), Social Security Number or Taxpayer Identification Number, Passport (if so, select a Country), or Alien Registration Number. If you have a Social Security Number, you must provide it.',
  },
  selectSuffix: {
    id: 'App.LeaseApplicationForm.selectSuffix',
    defaultMessage: 'Select suffix',
  },
  selectState: {
    id: 'App.LeaseApplicationForm.selectState',
    defaultMessage: 'Select state',
  },
  selectCountry: {
    id: 'App.LeaseApplicationForm.selectCountry',
    defaultMessage: 'Select country',
  },
  requiredFields: {
    id: 'App.LeaseApplicationForm.requiredFields',
    defaultMessage: 'Required Fields',
  },
  applicationForm: {
    id: 'App.LeaseApplicationForm.applicationForm',
    defaultMessage: 'APPLICATION FORM',
  },
  pendingResidentElectronicSigningTooltip: {
    id: 'App.LeaseApplicationForm.pendingResidentElectronicSigningTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'This household member cannot access Portal until their application is approved. Only manual signing is available while the application is pending.',
  },
  pendingResidentElectronicSigningInvalid: {
    id: 'App.LeaseApplicationForm.pendingResidentElectronicSigningInvalid',
    defaultMessage:
      // eslint-disable-next-line max-len
      "Electronic signing is not available while this household member's application is pending. Choose Manual Signing.",
  },
});

export default messages;
